// Status renkleri — kod bazlı; bilinmeyen kodlar için fallback
// Gönderim listesi ve kanban görünümleri arasında paylaşılır
const STATUS_COLOR_MAP = {
  FORWARDED: { bg: 'rgba(245, 158, 11, 0.16)', border: 'rgba(245, 158, 11, 0.45)', text: '#f59e0b' },
  INPRODUCTION: { bg: 'rgba(99, 102, 241, 0.16)', border: 'rgba(99, 102, 241, 0.45)', text: '#818cf8' },
  SHIPPED: { bg: 'rgba(20, 184, 166, 0.16)', border: 'rgba(20, 184, 166, 0.45)', text: '#2dd4bf' },
};

const FALLBACK_COLOR = { bg: 'rgba(148, 163, 184, 0.16)', border: 'rgba(148, 163, 184, 0.45)', text: '#94a3b8' };

export function statusColor(code) {
  if (!code) return FALLBACK_COLOR;
  return STATUS_COLOR_MAP[code.toUpperCase()] || FALLBACK_COLOR;
}

// Backend'deki Status.Code'u normalize eder — "Completed" gibi değerleri büyük harfle karşılaştırmak için
export function isCompletedCode(code) {
  return (code || '').toUpperCase() === 'COMPLETED';
}
